import { render, staticRenderFns } from "./EditarContacto.vue?vue&type=template&id=5e4bc2c6"
import script from "./EditarContacto.vue?vue&type=script&lang=js"
export * from "./EditarContacto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports